import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  ProductListPage,
  ProductEditPage,
  ProductSKUsPage,
  ProductCreatePage,
  ProductInformationPage,
} from './imports';

export const productRoutes = [
  {
    path: 'products',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRODUCT}
            access={OrionAccess.VIEW}
          >
            <ProductListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: ':id/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.PARTNER.PRODUCT}
            access={OrionAccess.VIEW}
          >
            <ProductInformationPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/skus',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.PARTNER.SKU}
            access={OrionAccess.VIEW}
          >
            <ProductSKUsPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRODUCT}
            access={OrionAccess.VIEW}
          >
            <ProductListPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRODUCT}
            access={OrionAccess.UPDATE}
          >
            <ProductEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRODUCT}
            access={OrionAccess.CREATE}
          >
            <ProductCreatePage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
